import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Mesh } from './Mesh.js';
import { Vec2 } from '../math/Vec2.js';
import { throwWarning } from '../utils/utils.js';
/***
 Here we create our DOMGLObject object
 We will extend our Mesh class object by adding HTML sizes helpers (bounding boxes getter/setter and mouse to mesh positioning)

 params:
 @renderer (Curtains renderer or Renderer class object): our curtains object OR our curtains renderer object
 @plane (html element): the html element that we will use for our DOMMesh object
 @type (string): Object type (should be either "Plane" or "ShaderPass")
 @Meshparams (object): see Mesh class object
 
 returns:
 @this: our BasePlane element
 ***/
// avoid reinstancing those during runtime

var tempVec2a = new Vec2();
var tempVec2b = new Vec2();
export var DOMMesh = /*#__PURE__*/function (_Mesh) {
  _inherits(DOMMesh, _Mesh);

  var _super = _createSuper(DOMMesh);

  function DOMMesh(renderer, htmlElement) {
    var _this;

    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "DOMMesh";

    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        widthSegments = _ref.widthSegments,
        heightSegments = _ref.heightSegments,
        renderOrder = _ref.renderOrder,
        depthTest = _ref.depthTest,
        cullFace = _ref.cullFace,
        uniforms = _ref.uniforms,
        vertexShaderID = _ref.vertexShaderID,
        fragmentShaderID = _ref.fragmentShaderID,
        vertexShader = _ref.vertexShader,
        fragmentShader = _ref.fragmentShader,
        texturesOptions = _ref.texturesOptions,
        crossOrigin = _ref.crossOrigin;

    _classCallCheck(this, DOMMesh);

    // handling HTML shaders scripts
    vertexShaderID = vertexShaderID || htmlElement && htmlElement.getAttribute("data-vs-id");
    fragmentShaderID = fragmentShaderID || htmlElement && htmlElement.getAttribute("data-fs-id");
    _this = _super.call(this, renderer, type, {
      widthSegments: widthSegments,
      heightSegments: heightSegments,
      renderOrder: renderOrder,
      depthTest: depthTest,
      cullFace: cullFace,
      uniforms: uniforms,
      vertexShaderID: vertexShaderID,
      fragmentShaderID: fragmentShaderID,
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
      texturesOptions: texturesOptions,
      crossOrigin: crossOrigin
    }); // return if no gl context

    if (!_this.gl) {
      return _possibleConstructorReturn(_this);
    } // our HTML element


    _this.htmlElement = htmlElement;

    if (!_this.htmlElement || _this.htmlElement.length === 0) {
      if (!_this.renderer.production) throwWarning(_this.type + ": The HTML element you specified does not currently exists in the DOM");
    } // set plane sizes


    _this._setDocumentSizes();

    return _this;
  }
  /*** PLANE SIZES ***/

  /***
   Set our plane dimensions and positions relative to document
   Triggers reflow!
   ***/


  _createClass(DOMMesh, [{
    key: "_setDocumentSizes",
    value: function _setDocumentSizes() {
      // set our basic initial infos
      var planeBoundingRect = this.htmlElement.getBoundingClientRect();
      if (!this._boundingRect) this._boundingRect = {}; // set plane dimensions in document space

      this._boundingRect.document = {
        width: planeBoundingRect.width * this.renderer.pixelRatio,
        height: planeBoundingRect.height * this.renderer.pixelRatio,
        top: planeBoundingRect.top * this.renderer.pixelRatio,
        left: planeBoundingRect.left * this.renderer.pixelRatio
      };
    }
  }, {
    key: "getBoundingRect",
    value:
    /*** BOUNDING BOXES GETTERS ***/

    /***
     Useful to get our plane HTML element bounding rectangle without triggering a reflow/layout
       returns :
     @boundingRectangle (obj): an object containing our plane HTML element bounding rectangle (width, height, top, bottom, right and left properties)
     ***/
    function getBoundingRect() {
      return {
        width: this._boundingRect.document.width,
        height: this._boundingRect.document.height,
        top: this._boundingRect.document.top,
        left: this._boundingRect.document.left,
        // right = left + width, bottom = top + height
        right: this._boundingRect.document.left + this._boundingRect.document.width,
        bottom: this._boundingRect.document.top + this._boundingRect.document.height
      };
    }
    /***
     Handles each plane resizing
     used internally when our container is resized
     ***/

  }, {
    key: "resize",
    value: function resize() {
      var _this2 = this;

      // reset plane dimensions
      this._setDocumentSizes(); // if this is a Plane object we need to update its perspective and positions


      if (this.type === "Plane") {
        // reset perspective
        this.setPerspective(this.camera.fov, this.camera.near, this.camera.far); // apply new position

        this._setWorldSizes();

        this._applyWorldPositions();
      } // resize all textures


      for (var i = 0; i < this.textures.length; i++) {
        this.textures[i].resize();
      } // handle our after resize event


      this.renderer.nextRender.add(function () {
        return _this2._onAfterResizeCallback && _this2._onAfterResizeCallback();
      });
    }
    /*** INTERACTION ***/

    /***
     This function takes the mouse position relative to the document and returns it relative to our plane
     It ranges from -1 to 1 on both axis
       params :
     @mouseCoordinates (Vec2 object): coordinates of the mouse
       returns :
     @mousePosition (Vec2 object): the mouse position relative to our plane in WebGL space coordinates
     ***/

  }, {
    key: "mouseToPlaneCoords",
    value: function mouseToPlaneCoords(mouseCoordinates) {
      // remember our ShaderPass objects don't have a scale property
      var scale = this.scale ? this.scale : tempVec2b.set(1, 1); // we need to adjust our plane document bounding rect to it's webgl scale

      var scaleAdjustment = tempVec2a.set((this._boundingRect.document.width - this._boundingRect.document.width * scale.x) / 2, (this._boundingRect.document.height - this._boundingRect.document.height * scale.y) / 2); // also we need to divide by pixel ratio

      var planeBoundingRect = {
        width: this._boundingRect.document.width * scale.x / this.renderer.pixelRatio,
        height: this._boundingRect.document.height * scale.y / this.renderer.pixelRatio,
        top: (this._boundingRect.document.top + scaleAdjustment.y) / this.renderer.pixelRatio,
        left: (this._boundingRect.document.left + scaleAdjustment.x) / this.renderer.pixelRatio
      }; // mouse position conversion from document to plane space

      return tempVec2a.set((mouseCoordinates.x - planeBoundingRect.left) / planeBoundingRect.width * 2 - 1, 1 - (mouseCoordinates.y - planeBoundingRect.top) / planeBoundingRect.height * 2);
    }
    /*** EVENTS ***/

    /***
     This is called each time a plane has been resized
       params :
     @callback (function) : a function to execute
       returns :
     @this: our plane to handle chaining
     ***/

  }, {
    key: "onAfterResize",
    value: function onAfterResize(callback) {
      if (callback) {
        this._onAfterResizeCallback = callback;
      }

      return this;
    }
  }]);

  return DOMMesh;
}(Mesh);